import { render, staticRenderFns } from "./Archivetest.vue?vue&type=template&id=2f2faf3d"
import script from "./Archivetest.vue?vue&type=script&lang=js"
export * from "./Archivetest.vue?vue&type=script&lang=js"
import style0 from "./Archivetest.vue?vue&type=style&index=0&id=2f2faf3d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports